export const UsersData = [
  {
    id: 1,
    username: 'Sharmaji',
    age: 10,
  },
  {
    id: 2,
    username: 'Abhishek',
    age: 20,
  },
  {
    id: 3,
    username: 'Abeer',
    age: 30,
  },
  {
    id: 4,
    username: 'Sachin',
    age: 40,
  },
  {
    id: 5,
    username: 'Megha',
    age: 50,
  },
  {
    id: 6,
    username: 'Tejendra',
    age: 60,
  },
  {
    id: 7,
    username: 'Shivani',
    age: 70,
  },
  {
    id: 8,
    username: 'Zafar',
    age: 80,
  },
];
